import { actions } from '../utils/constants';

export const setToken = token => ({
    type: actions.SET_TOKEN,
    payload: token
})

export const getUserLogged = id => ({
    type: actions.ASYNC_GET_USER_LOGGED,
    payload: id
})


// WEBPACK FOOTER //
// ./src/App/App.actions.js